export default __webpack_public_path__ + "static/media/square.83c19017.svg";